module.exports = __webpack_public_path__ + "static/media/searchIcon.16c39fa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Search/searchIcon.svg
// module id = 1433
// module chunks = 0